module.exports = __webpack_public_path__ + "img/keyboard.038ce0cd.svg";